import React, { JSXElementConstructor } from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@mui/material';

export type CardIdType = 'exercise'|'survey'|'manual';
export type Props = {
  MuiIcon: JSXElementConstructor<any>;
  text: string;
  id: CardIdType;
  onCardClick: (id: CardIdType) => void;
}

const SelectionCard: React.FC<Props> = ({
  MuiIcon,
  text,
  id,
  onCardClick,
}: Props) => {
  const onCardClickHandler = () => {
    onCardClick(id);
  };

  return (
    <Card sx={{ width: 250, height: 250 }}>
      <CardActionArea onClick={onCardClickHandler}>
        <CardContent sx={{ width: 250, height: 250 }}>
          <Box sx={{ mt: 5 }}>
            <MuiIcon
              style={{
                position: 'relative',
                top: '25%',
                left: 60,
                height: 100,
                width: 100,
                color: 'grey[800]',
              }}
            />
          </Box>
          <Typography textAlign="center">
            {text}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default SelectionCard;
